
class ScrollableController {
    static $inject = ["$scope"];

    public element: ng.IAugmentedJQuery;

    constructor($scope: ng.IScope) { }
}

export function Scrollable(): ng.IDirective {
    return {
        restrict: 'A',
        compile: (element: ng.IAugmentedJQuery) => {
            return {
                pre: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: ScrollableController) => {
                    var scrollWrap = $('<div class="scroll-wrap"></div>');
                    element.addClass('scrollable');
                    element.before(scrollWrap);
                    element.appendTo(scrollWrap);
                    controller.element = element;
                },
                post: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: ScrollableController) => {

                }
            }
        },
        controller: ScrollableController
    }
}

ScrollableStickyTableHeader.$inject = ["$compile"];
export function ScrollableStickyTableHeader($compile: ng.ICompileService): ng.IDirective {
    return {
        restrict: 'A',
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: ScrollableController) => {
            var thead = element.find('thead');

            var tableAppended = false;
            // new table container
            var divContainer = $('<div class="scrollable"></div>');
            controller.element.on('scroll', (event) => {
                var container = controller.element;
                if (!tableAppended) {
                    // hide scrollbar on new container that will assuredly not work on a huge number of browsers
                    divContainer.addClass('hide-scroll');
                    tableAppended = true;
                    // clone of table
                    var tableClone = element.clone();
                    // remove all contents of clone
                    tableClone.html('');
                    // remove this directive
                    tableClone.removeAttr('rl-sticky-header');

                    // append a clone of current thead
                    tableClone.append(thead.clone());
                    // for each th element we need to calculate what it's width is in the primary table so that the columns align properly
                    tableClone.find('th').each((i, e) => {
                        var headerTh = element.find('th').eq(i)

                        var cellWidth = headerTh.css('width');
                        var cell = $(e);
                        // we can't have ng-repeat run anymore
                        cell.removeAttr('ng-repeat');
                        cell.css('min-width', cellWidth)
                        cell.css('max-width', cellWidth);
                    });

                    thead.css('visibility', 'hidden');
                    divContainer.append(tableClone);
                    var tableContainer = $compile(divContainer)(scope);

                    container.before(tableContainer);

                } else {
                    // tie the scroll event of the primary table container to our header container
                    divContainer.scrollLeft(container.scrollLeft());
                }
            });
        },
        require: '^rlScrollable'
    }
}
